<template>
  <div class="ui form">
    <div class="field" v-for="(attribute, index) in attributes" :key="index">
      <label for="">{{ attribute.name }}</label>
      <input type="text" name="" v-model="attributes[index].value" />
    </div>
  </div>
</template>

<script>
// import { local_api, error_toast } from "@/utils";
import { cloneDeep } from "lodash";

export default {
  name: "CourseModalGeneral",
  props: {
    course_in: Object,
    course_configuration: Object,
  },
  components: {},
  data() {
    return {
      attributes: [],
    };
  },
  methods: {
    getList() {
      return this.attributes;
    },
  },
  // created() {
  //   let vm = this;
  //   local_api(this, "post", "/course/setting/do-get-configuration")
  //     .then((conf) => {
  //       if (conf && conf.setup && conf.setup.attributes) {
  //         vm.attributes = conf.setup.attributes;
  //       }
  //     })
  //     .catch((err) => {
  //       error_toast(err);
  //     });
  // },
  mounted() {
    let vm = this;
    setTimeout(() => {
      if (vm.course_configuration && vm.course_configuration.attributes) {
        vm.attributes = vm.course_configuration.attributes;
      }

      if (vm.course_in) {
        if (vm.attributes) {
          vm.attributes.map((att) => {
            let trgt = vm.course_in.setup.general.find((at) => {
              return at.id == att.id;
            });
            if (trgt) att.value = trgt.value;
          });
        } else {
          vm.attributes = cloneDeep(vm.course_in.setup.general);
        }
      }
    }, 300);

    // this.processing = true;
    // if (vm.product_in && vm.product_in.setup) {
    //   vm.products = vm.product_in.setup.compoundment || [];
    // }
    // setTimeout(function() {
    //   local_api(vm, "post", "/customer_email/do-get-initial-items", {
    //     uuid: vm.$props.customer.uuid
    //   })
    //     .then(items => {
    //       vm.addresses = items;
    //       vm.all_addresses = clone(items);
    //       vm.processing = false;
    //     })
    //     .catch(err => {
    //       error_toast(err);
    //       console.error(err);
    //     });
    // }, 100);
  },
  watch: {},
};
</script>
